import { Analytics } from '@genoa/analytics'

import { AutopaySetupContainer } from '../../common/autopay-setup'

export const OnboardingAutopaySetupContainer = () => {
  return <AutopaySetupContainer analyticsScreenName={Analytics.Screens.ONBOARDING_AUTOPAY_SETUP} />
}
